import { useGalleryStore } from "../../../stores/Gallery.store";
import ListingImageGallery from "../../../components/ListingImageGallery/ListingImageGallery";
import React from "react";

const GalleryImages = () => {
  const { isShow, onClose, images } = useGalleryStore();

  return (
    <ListingImageGallery
      isShowModal={isShow}
      onClose={onClose}
      images={images}
    />
  );
};

export default GalleryImages;
